import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

const Header = props => {
  return (
    <div id="menu"><div id="menu-wrap">
      <ul>
        <li className={(props.selected === 'product') ? 'selected' : null}>
          <Link to={`/`}>Products</Link>
        </li>
        <li className={(props.selected === 'pay') ? 'selected' : null}>
          <Link to={`/pay`}>Direct Pay</Link>
        </li>
        <li className={(props.selected === 'transactions') ? 'selected' : null}>
          <Link to={`/transactions`}>Transactions</Link>
        </li>
        <li className={(props.selected === 'settings') ? 'selected' : null}>
          <Link to={`/settings`}>Settings</Link>
        </li>
      </ul>
    </div></div>
  )
}

export default Header
